module.exports = __webpack_public_path__ + "img/brand-voice.fd45089e.png";